<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h2 class="dialog-title" mat-dialog-title>Pick qualified teams with the same points</h2>
<mat-dialog-content class="content-container">
  <p class="info-text" #infoText>
    Their are some teams with the same points on the edge of qualification. Pleas drag and drop the
    teams to decide which teams should qualify for the knockout phase.
  </p>
  <!--
  There are three tables in this component:
  1. A table with the teams that are guaranteed to qualify for the knockout phase.
  2. A table with the teams that are on the edge of qualification. These teams have the same wins/points.
  3. A table with the teams that are guaranteed to not qualify for the knockout phase.

  The second table is a cdkDropList, which means that the user can drag and drop the teams to decide which teams should qualify for the knockout phase.
  -->
  <div class="table-container">
    <!-- Guaranteed qualified teams -->
    <mat-table [dataSource]="guaranteedQualifiedTeams()" class="table-with-bottom-border">
      <ng-container matColumnDef="position" sticky>
        <mat-header-cell *matHeaderCellDef> No.</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>{{ asScoreDto(element).position }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ asScoreDto(element).name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="wins">
        <mat-header-cell *matHeaderCellDef> Wins</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ asScoreDto(element).wins }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="points">
        <mat-header-cell *matHeaderCellDef> Points</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ asScoreDto(element).points }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="dragIcon">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element"></mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <!-- Teams on the edge of qualification -->
    <div class="drag-and-drop-container table-with-bottom-border">
      <mat-table
        #dragAndDropTable
        [dataSource]="edgeTeamsWithSamePoints()"
        class=""
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        cdkDropListData="dataSource"
      >
        <ng-container matColumnDef="position" sticky>
          <mat-header-cell *matHeaderCellDef> No.</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ asScoreDto(element).position }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Name</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ asScoreDto(element).name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="wins">
          <mat-header-cell *matHeaderCellDef> Wins</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ asScoreDto(element).wins }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="points">
          <mat-header-cell *matHeaderCellDef> Points</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ asScoreDto(element).points }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="dragIcon">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon class="drag-cursor">reorder</mat-icon>
          </mat-cell>
        </ng-container>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          cdkDrag
          cdkDragLockAxis="y"
          #dragAndDropTableRow
          [cdkDragData]="row"
        ></mat-row>
      </mat-table>
      <!--
    The following div is a hint for the user. It shows the user which teams are going to be in the knockout phase and which teams not.
    -->
      <div class="sixteen-hint-container" #qualifiedInfo>
        <div class="sixteen-hint-top-left">
          <mat-icon>arrow_upward</mat-icon>
        </div>
        <div class="sixteen-hint-top-right">Qualified for the knockout phase</div>
        <div class="sixteen-hint-bottom-left">
          <mat-icon>arrow_downward</mat-icon>
        </div>
        <div class="sixteen-hint-bottom-right">Not qualified for the knockout phase</div>
      </div>
    </div>
    <!-- Guaranteed not qualified teams -->
    <mat-table [dataSource]="guaranteedNotQualifiedTeams()">
      <ng-container matColumnDef="position" sticky>
        <mat-header-cell *matHeaderCellDef> No.</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>{{ element.position }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="wins">
        <mat-header-cell *matHeaderCellDef> Wins</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ asScoreDto(element).wins }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="points">
        <mat-header-cell *matHeaderCellDef> Points</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ asScoreDto(element).points }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="dragIcon">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element"></mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-flat-button color="primary" (click)="printQualifiedTeams()">
    Start KO phase with selected Teams
  </button>
</mat-dialog-actions>
